import React, { useEffect } from "react";
import { useQuery } from "../../../../../_utils/url_query_hook";
import { useFormById } from "../../../../../_hooks/form/useFormById.hook";
import TermsInfo from "./term_info";
import { Nav } from "react-bootstrap";
import TotalInfo from "./total_info";
import { useAcademicPartAllWithFormBySFAndTerm } from "../../../../../_hooks/academic_part/useAcademicPartAllWithFormBySFAndTerm.hook";

function FormTabs(){
    
    const query = useQuery();
    const uuid = query.get("id");
    const formHook = useFormById(uuid);

    if(formHook.data) {
        return (
            <Tabs formHook={formHook} />
        );
    }
    else
    return (
        <></>
    );
}

function Tabs({formHook}) {
    const studentFormEvaluationsHook =  useAcademicPartAllWithFormBySFAndTerm(formHook.data?.students ? formHook.data.students.length > 0 ? {...formHook.data.students[0]} : '' : '', '1') ;

    useEffect(() => {
        const studentForm = formHook.data?.students ? formHook.data.students.length > 0 ? {...formHook.data.students[0]} : '' : '';
        studentFormEvaluationsHook.setSelected(formHook.data?.students ? formHook.data.students.length > 0 ? {...formHook.data.students[0]} : '' : '');
        if(studentForm !== '') studentFormEvaluationsHook.loadData(studentForm.uuid, studentFormEvaluationsHook.selectedTerm);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formHook.data.students]);

    return(
        <div>
                <div>
                    <Nav variant="tabs" defaultActiveKey="1">                
                        <Nav.Item>
                            <Nav.Link onClick={() => studentFormEvaluationsHook.setSelectedTerm('1')} eventKey="1">Corte 1</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link onClick={() => studentFormEvaluationsHook.setSelectedTerm('2')} eventKey="2">Corte 2</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link onClick={() => studentFormEvaluationsHook.setSelectedTerm('3')} eventKey="3">Corte 3</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link onClick={() => studentFormEvaluationsHook.setSelectedTerm('4')} eventKey="4">Total</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
                <div style={{ marginTop: '20px' }}>
                    {
                        studentFormEvaluationsHook.selectedTerm === '1' &&
                        <TermsInfo
                            term={studentFormEvaluationsHook.selectedTerm}
                            students={formHook.data? formHook.data.students : []}
                            studentFormEvaluationsHook={studentFormEvaluationsHook}
                        />
                    }
                    {
                        studentFormEvaluationsHook.selectedTerm === '2' &&
                        <TermsInfo
                            term={studentFormEvaluationsHook.selectedTerm}
                            students={formHook.data? formHook.data.students : []}
                            studentFormEvaluationsHook={studentFormEvaluationsHook}
                        />
                    }
                    {
                        studentFormEvaluationsHook.selectedTerm === '3' &&
                        <TermsInfo
                            term={studentFormEvaluationsHook.selectedTerm}
                            students={formHook.data? formHook.data.students : []}
                            studentFormEvaluationsHook={studentFormEvaluationsHook}
                        />
                    }
                    {
                        studentFormEvaluationsHook.selectedTerm === '4' &&
                        <TotalInfo
                            students={formHook.data? formHook.data.students : []}
                            studentFormEvaluationsHook={studentFormEvaluationsHook}
                        />
                    }
                </div>
            </div>
    );
}

export default FormTabs;